// ============================================================================
// KOREAN TRANSLATIONS - CHAPTER 2: 출애굽기
// ============================================================================
// 레벨 14-26 (13레벨, 39문제)

export const chapter2Translations = {
  name: "출애굽기",
  description: "하나님의 백성의 해방……하나님을 아는 것은 우리의 삶을 변화시킵니다",
  
  spiritualWisdom: {
    principle: "하나님에 대한 지식은 해방하고 변화시킨다",
    scripture: "진리를 알지니 진리가 너희를 자유롭게 하리라 (요한복음 8:32)",
    application: "이스라엘이 이집트에서 해방되었듯이, 하나님에 대한 지식은 우리를 영적 노예 상태에서 해방시킵니다"
  },
  
  levels: {
    14: {
      name: "물에서 구출된 모세",
      challenge: "여인이 임신하여 아들을 낳으니 그가 아름다운 것을 보고……",
      easy: {
        question: "모세의 어머니는 그를 무엇에 숨겼습니까?",
        options: ["동굴", "갈대 상자", "바구니", "집"],
        hint: "나일강에 떠 있던 용기",
        funFact: "🏺 갈대 상자는 방수를 위해 역청으로 칠해져 있었습니다!"
      },
      medium: {
        question: "갈대 숲에서 모세를 발견한 사람은 누구입니까?",
        options: [
          "바로의 딸",
          "이집트 여종",
          "누나 미리암",
          "이집트 제사장"
        ],
        hint: "이집트 왕실의 일원",
        funFact: "👑 아이러니하게도, 바로의 가족이 그에게 도전할 자를 구했습니다!"
      },
      hard: {
        question: "하나님의 섭리는 어떻게 원수조차 사용하십니까?",
        options: [
          "그들을 개종시킴으로써",
          "자신의 목적을 이루기 위해 상황을 조율함으로써",
          "그들을 벌함으로써",
          "그들을 무시함으로써"
        ],
        hint: "사건 속에서 하나님의 손을 보는 것에 관한 것입니다",
        funFact: "✨ 모세는 자기 백성을 억압하던 자의 궁전에서 성장했습니다!"
      }
    },
    
    15: {
      name: "불타는 떨기나무",
      challenge: "여호와의 사자가 떨기나무 불꽃 중에 그에게 나타났더라……",
      easy: {
        question: "불타는 떨기나무 앞에서 모세는 무엇을 벗어야 했습니까?",
        options: ["보석", "신발", "겉옷", "터번"],
        hint: "발에 신는 것",
        funFact: "👡 신발을 벗는 것은 거룩한 땅에 대한 존경을 표현합니다!"
      },
      medium: {
        question: "하나님은 모세에게 무슨 이름을 계시하셨습니까?",
        options: [
          "여호와",
          "나는 스스로 있는 자니라",
          "전능자",
          "창조주"
        ],
        hint: "절대적 존재를 표현하는 이름",
        funFact: "🔥 YHWH (나는 있다)는 하나님의 영원한 본질을 계시합니다!"
      },
      hard: {
        question: "타도 타지 않는 떨기나무는 무엇을 가르칩니까?",
        options: [
          "마법이 존재한다",
          "하나님은 자연 법칙을 초월하신다",
          "불은 신성하다",
          "식물은 마법적이다"
        ],
        hint: "우리의 이해를 넘어서는 하나님의 본성에 관한 것입니다",
        funFact: "🌿 떨기나무는 하나님의 임재가 파괴하지 않고 성별함을 상징합니다!"
      }
    },

    16: {
      name: "이집트의 열 가지 재앙",
      challenge: "바로가 그 마음을 완강하게 하여 그들의 말을 듣지 아니하였더라……",
      easy: {
        question: "이집트의 첫 번째 재앙은 무엇이었습니까?",
        options: ["개구리", "물이 피로 변함", "파리", "이"],
        hint: "이집트의 생명의 원천인 나일강에 영향을 미쳤습니다",
        funFact: "🩸 나일강은 신으로 숭배되었는데, 하나님은 그 우월함을 보이셨습니다!"
      },
      medium: {
        question: "마지막이자 가장 무서운 재앙은 무엇이었습니까?",
        options: [
          "우박",
          "흑암",
          "장자의 죽음",
          "메뚜기"
        ],
        hint: "이 재앙은 가족에게 직접 영향을 미쳤습니다",
        funFact: "😢 이 재앙이 마침내 바로의 교만을 꺾고 이스라엘을 해방시켰습니다!"
      },
      hard: {
        question: "왜 하나님은 바로의 마음을 완강하게 하셨습니까?",
        options: [
          "그를 벌하기 위해",
          "자신의 영광과 능력을 나타내기 위해",
          "악의로",
          "고통을 연장하기 위해"
        ],
        hint: "참된 하나님이 누구인지 드러내는 것에 관한 것입니다",
        funFact: "⚡ 재앙들은 YHWH가 모든 이집트 신들보다 강력함을 보여주었습니다!"
      }
    },

    17: {
      name: "유월절",
      challenge: "어린 양을 취하고……그 피를 문 인방과 문설주에 바르라……",
      easy: {
        question: "이스라엘 사람들은 어린 양의 피를 어디에 발라야 했습니까?",
        options: [
          "옷에",
          "문 인방과 문설주에",
          "이마에",
          "잔에"
        ],
        hint: "집 입구에",
        funFact: "🩸 문의 피는 하나님의 보호의 표시였습니다!"
      },
      medium: {
        question: "유월절 어린 양을 어떻게 먹어야 했습니까?",
        options: [
          "편안하게 앉아서",
          "가족끼리만",
          "허리에 띠를 띠고 발에 신을 신고 손에 지팡이를 잡고",
          "침묵 속에서"
        ],
        hint: "출발 준비를 하고",
        funFact: "🚶 그들은 자유를 향해 빨리 출발할 준비가 되어 있어야 했습니다!"
      },
      hard: {
        question: "유월절 어린 양은 어떻게 그리스도를 예표합니까?",
        options: [
          "그 흰색으로",
          "죽음에서 구하는 대속의 희생으로",
          "그 온유함으로",
          "그 나이로"
        ],
        hint: "정죄에서 면하게 하는 희생에 관한 것입니다",
        funFact: "🐑 예수님은 '세상 죄를 지고 가는 하나님의 어린 양'이라고 불립니다!"
      }
    },

    18: {
      name: "홍해 횡단",
      challenge: "모세가 바다 위로 손을 내밀었더니……",
      easy: {
        question: "이스라엘 사람들은 어떻게 바다를 건넜습니까?",
        options: [
          "배로",
          "수영하여",
          "마른 땅을 걸어서",
          "뗏목으로"
        ],
        hint: "해저가 걸을 수 있게 되었습니다",
        funFact: "🌊 하나님은 장애물을 해방의 길로 바꾸셨습니다!"
      },
      medium: {
        question: "추격해 온 이집트인들에게 무슨 일이 일어났습니까?",
        options: [
          "되돌아갔다",
          "물에 삼켜졌다",
          "길을 잃었다",
          "이스라엘에 합류했다"
        ],
        hint: "물이 그들 위로 되돌아왔습니다",
        funFact: "⚔️ 세계에서 가장 강력한 군대가 순식간에 파괴되었습니다!"
      },
      hard: {
        question: "이 횡단은 우리의 영적 삶에서 무엇을 상징합니까?",
        options: [
          "문제로부터의 도피",
          "죄의 노예 상태에서 하나님 안의 자유로의 이행",
          "이스라엘의 우월성",
          "원수의 파괴"
        ],
        hint: "영적 변화에 관한 것입니다",
        funFact: "🗽 홍해는 세례를 나타냅니다: 옛 것에 대한 죽음, 새 생명!"
      }
    },

    19: {
      name: "광야의 만나",
      challenge: "이것이 무엇이냐? 그들은 그것이 무엇인지 알지 못하였으므로……",
      easy: {
        question: "만나는 얼마 동안 내렸습니까?",
        options: ["10년", "20년", "40년", "50년"],
        hint: "광야에서 보낸 년수와 같습니다",
        funFact: "🍞 40년 동안 하나님은 200만 명을 기적적으로 먹이셨습니다!"
      },
      medium: {
        question: "만나를 하루 이상 보관하면 어떻게 되었습니까?",
        options: [
          "더 맛있어졌다",
          "늘어났다",
          "썩어서 악취가 났다",
          "딱딱해졌다"
        ],
        hint: "안식일을 위한 금요일은 제외",
        funFact: "🪱 하나님은 이렇게 하나님께 대한 날마다의 의존을 가르치셨습니다!"
      },
      hard: {
        question: "만나는 신뢰에 대해 무엇을 가르칩니까?",
        options: [
          "미래를 위해 비축하는 것",
          "하나님의 날마다의 섭리에 의지하는 것",
          "더 열심히 일하는 것",
          "공평하게 나누는 것"
        ],
        hint: "날마다 신뢰하는 것에 관한 것입니다",
        funFact: "🙏 '오늘 우리에게 일용할 양식을 주시옵소서'는 이 경험에서 나왔습니다!"
      }
    },

    20: {
      name: "바위에서 나온 물",
      challenge: "바위를 치라, 그러면 그곳에서 물이 나올 것이다……",
      easy: {
        question: "모세는 바위를 어떻게 쳐야 했습니까?",
        options: ["손으로", "지팡이로", "발로", "검으로"],
        hint: "하나님이 그에게 주신 도구",
        funFact: "🪨 단순한 순종이 초자연적인 기적을 일으켰습니다!"
      },
      medium: {
        question: "왜 사람들이 목말라했습니까?",
        options: [
          "더위 때문에",
          "사막에 물이 없었기 때문에",
          "긴 여정 때문에",
          "병 때문에"
        ],
        hint: "그들의 환경에 관한 것입니다",
        funFact: "💧 하나님은 메마른 사막에서 물의 원천을 만들어내셨습니다!"
      },
      hard: {
        question: "이 바위는 그리스도에 대해 무엇을 예표합니까?",
        options: [
          "그 강함",
          "맞아서 생명의 물을 주심",
          "그 크기",
          "그 위치"
        ],
        hint: "구원의 원천에 관한 것입니다",
        funFact: "⚡ 바울은 말했습니다: '그 바위는 그리스도였습니다'(고린도전서 10:4)!"
      }
    },

    21: {
      name: "십계명",
      challenge: "하나님께서 이 모든 말씀으로 말씀하시되……",
      easy: {
        question: "하나님은 어디에서 십계명을 주셨습니까?",
        options: ["이집트에서", "시내 산에서", "가나안에서", "광야에서"],
        hint: "불과 연기가 있던 거룩한 산",
        funFact: "🔥 하나님의 임재가 산 전체를 흔들었습니다!"
      },
      medium: {
        question: "십계명은 무엇에 새겨졌습니까?",
        options: [
          "양피지에",
          "하나님의 손가락으로 돌판에",
          "나무에",
          "금에"
        ],
        hint: "영구적인 재료",
        funFact: "👆 하나님 자신이 그분의 율법을 쓰셨습니다!"
      },
      hard: {
        question: "율법의 목적은 무엇입니까?",
        options: [
          "사람을 구원하는 것",
          "죄를 드러내고 하나님의 거룩한 본성을 보이는 것",
          "사람을 벌하는 것",
          "사람을 노예로 만드는 것"
        ],
        hint: "하나님의 기준을 드러내는 것에 관한 것입니다",
        funFact: "📜 율법은 우리를 그리스도의 필요성으로 인도합니다!"
      }
    },

    22: {
      name: "금송아지",
      challenge: "그들이 장신구를 벗어 아론에게 가져왔더라……",
      easy: {
        question: "모세가 없는 동안 백성들은 무엇을 만들었습니까?",
        options: [
          "새 장막",
          "금송아지",
          "금 기념비",
          "새 제단"
        ],
        hint: "우상 숭배의 대상",
        funFact: "🐄 그들은 해방의 하나님을 버리고 우상을 섬겼습니다!"
      },
      medium: {
        question: "이 죄에 대해 모세는 어떻게 반응했습니까?",
        options: [
          "기뻐했다",
          "화가 나서 돌판을 깨뜨렸다",
          "도망쳤다",
          "무시했다"
        ],
        hint: "그의 격렬한 반응",
        funFact: "😢 하나님의 율법이 어겨졌을 때, 모세는 율법을 깨뜨렸습니다!"
      },
      hard: {
        question: "왜 인간의 마음은 우상으로 기울어집니까?",
        options: [
          "무지 때문에",
          "보이는 것에 의지하려는 욕망과 하나님의 주권에 대한 반항",
          "악마의 영향 때문에",
          "약함 때문에"
        ],
        hint: "인간의 본성과 보이는 것에 대한 욕망에 관한 것입니다",
        funFact: "💔 우상 숭배는 창조주를 피조물로 대체합니다!"
      }
    },

    23: {
      name: "성막",
      challenge: "그들이 나를 위하여 성소를 짓게 하라……",
      easy: {
        question: "성막은 무엇이었습니까?",
        options: [
          "궁전",
          "하나님의 이동식 성소",
          "창고",
          "학교"
        ],
        hint: "하나님의 임재를 위한 장소",
        funFact: "⛺ 하나님은 그분의 백성 가운데 거하기를 원하셨습니다!"
      },
      medium: {
        question: "성막에서 가장 거룩한 곳은 어디였습니까?",
        options: [
          "제단",
          "지성소",
          "입구",
          "떡상"
        ],
        hint: "언약궤가 있던 곳",
        funFact: "✨ 대제사장만이 일년에 한 번 그곳에 들어갈 수 있었습니다!"
      },
      hard: {
        question: "성막은 무엇을 예표했습니까?",
        options: [
          "이스라엘의 힘",
          "임마누엘, 우리와 함께하시는 하나님, 그리스도로 성취됨",
          "제사장의 중요성",
          "의식의 아름다움"
        ],
        hint: "인간 가운데 거하시는 하나님에 관한 것입니다",
        funFact: "🙏 예수님은 우리 가운데 '장막을 치셨습니다'(요한복음 1:14)!"
      }
    },

    24: {
      name: "가나안 정탐꾼",
      challenge: "땅과 그 거민을 정탐하기 위해 사람을 보내라……",
      easy: {
        question: "가나안을 정탐하기 위해 몇 명의 정탐꾼이 보내졌습니까?",
        options: ["6명", "10명", "12명", "24명"],
        hint: "이스라엘 각 지파에서 한 명씩",
        funFact: "🕵️ 12명이 보내졌지만 2명만 믿음을 가졌습니다!"
      },
      medium: {
        question: "믿음을 가진 두 정탐꾼은 누구였습니까?",
        options: [
          "모세와 아론",
          "여호수아와 갈렙",
          "아론과 미리암",
          "기드온과 삼손"
        ],
        hint: "가나안에 들어가기 위해 살아남은 사람들",
        funFact: "💪 그들의 믿음은 40년의 방랑 후에 보상받았습니다!"
      },
      hard: {
        question: "불신앙의 결과는 무엇이었습니까?",
        options: [
          "즉시 용서되었다",
          "40년 동안 광야를 방황했다",
          "즉시 벌을 받았다",
          "추방되었다"
        ],
        hint: "긴 결과",
        funFact: "😢 두려움이 전체 세대에게 약속의 땅 입성을 희생시켰습니다!"
      }
    },

    25: {
      name: "놋뱀",
      challenge: "불뱀들이 백성 중에 들어와 그들을 물었더라……",
      easy: {
        question: "백성을 문 뱀은 어떤 종류였습니까?",
        options: ["초록색", "불", "거대한", "보이지 않는"],
        hint: "그들의 치명적인 효과를 나타내는 형용사",
        funFact: "🐍 이 뱀들은 죄의 치명적인 결과를 상징했습니다!"
      },
      medium: {
        question: "백성을 구하기 위해 하나님은 모세에게 무엇을 하라고 명하셨습니까?",
        options: [
          "약을 만들다",
          "장대에 놋뱀을 달다",
          "기도하다",
          "뱀을 죽이다"
        ],
        hint: "믿음에 의한 행동",
        funFact: "⚕️ 보는 단순한 행위가 구원했습니다 - 믿음을 상징합니다!"
      },
      hard: {
        question: "예수님은 십자가에 대해 말씀하실 때 이 사건을 어떻게 인용하셨습니까?",
        options: [
          "죄의 위험성에 대해",
          "'모세가 광야에서 뱀을 든 것같이 인자도 들려야 하리니'",
          "순종의 필요성에 대해",
          "기도의 힘에 대해"
        ],
        hint: "믿음으로 인한 구원에 관한 것입니다",
        funFact: "✝️ 예수님은 놋뱀처럼 죄인을 구하기 위해 '들리셨습니다'!"
      }
    },

    26: {
      name: "약속의 땅",
      challenge: "네 눈으로 그것을 볼 수 있으나 거기에 가지는 못하리라……",
      easy: {
        question: "누가 이스라엘을 요단강을 건너 인도했습니까?",
        options: ["모세", "아론", "여호수아", "갈렙"],
        hint: "모세의 후계자",
        funFact: "🚶 여호수아의 이름은 예수와 같은 의미입니다: '주께서 구원하신다'!"
      },
      medium: {
        question: "왜 모세는 약속의 땅에 들어갈 수 없었습니까?",
        options: [
          "너무 늙었기 때문에",
          "므리바의 물에서의 불순종 때문에",
          "백성을 인도하기를 거부했기 때문에",
          "병들었기 때문에"
        ],
        hint: "이전의 특정한 죄",
        funFact: "😢 모세조차도 불순종의 결과에 직면했습니다!"
      },
      hard: {
        question: "약속의 땅은 무엇을 상징합니까?",
        options: [
          "물질적 풍요",
          "그리스도 안에서 하나님의 약속의 성취와 우리의 천국 유산",
          "이스라엘의 군사적 승리",
          "광야의 끝"
        ],
        hint: "하나님의 약속의 영적 성취에 관한 것입니다",
        funFact: "🌿 가나안은 우리를 기다리는 천국 고향을 가리킵니다!"
      }
    }
  }
};

export default chapter2Translations;
